module.exports = __webpack_public_path__ + "img/ERST_logo-Copy.e67f7b3c.png";